import PropTypes from 'prop-types';
import { createContext, useState } from 'react';

const getApiHost = () => {
  const domains = window.location.hostname.split('.');
  if (domains[0] === 'localhost') {
    return 'http://localhost:8000';
  } else {
    domains[0] = `${domains[0]}-api`;
    return `${window.location.protocol}//${domains.join('.')}`;
  }
};
export const getTenant = () => {
  const domains = window.location.hostname.split('.');
  return domains[0].replace('educat-', '');
};
export const getExamsUrl = () => {
  const domains = window.location.hostname.split('.');
  domains[0] = domains[0].replace('educat-', '').replace('-2022', '');
  domains[1] = domains.splice(1, domains.length).join('.');
  switch (domains[0]) {
    case '-nova-url':
      return `https://exams-plurall-2022.citecnologia.com.br`;
    case 'localhost':
      return `http://localhost:3001`
    default:
      return `${window.location.protocol}//exams-${domains[0]}-2022.${domains[1]}`;
  }
};

export const TITLE = process.env.REACT_APP_TITLE || 'eduCAT';
export const API_HOST = process.env.REACT_APP_API_HOST || getApiHost();
export const LEGACY_API_HOST = 'http://api.educat.net.br';
export const REVISAO_ITEM_API_HOST =
  process.env.REACT_APP_REVISAO_ITEM_API_HOST ||
  'https://api.revisao.educat.net.br';
export const PLAGIUS_API_HOST =
  process.env.REACT_APP_PLAGIUS_API_HOST || 'https://plagio.educat.net.br';
export const OPEN_WEB_UI_URL =
  process.env.REACT_APP_OPEN_WEB_UI_URL || 'https://ia-rj.educat.net.br';
export const ID_ITEM_AO_IMPRIMIR_AVALIACAO =
  process.env.REACT_APP_ID_ITEM_AO_IMPRIMIR_AVALIACAO || false;
export const AREAS_CONHECIMENTO_AO_IMPRIMIR_AVALIACAO =
  process.env.REACT_APP_AREAS_CONHECIMENTO_AO_IMPRIMIR_AVALIACAO || false;
export const COPYRIGHT_MESSAGE =
  process.env.REACT_APP_COPYRIGHT_MESSAGE || 'Copyright © 2019 eduCAT Eireli';
export const CONTACT_EMAIL =
  process.env.REACT_APP_CONTACT_EMAIL || 'contato@educat.com.br';
export const PERSONAL_ASSISTANT =
  process.env.PERSONAL_ASSISTANT || 'https://assistente-pessoal.educat.net.br/';

export const GOOGLE_ANALYTICS_KEY = process.env.REACT_APP_GOOGLE_ANALYTICS_KEY || false;
export const ANALYSIS_API_HOST =
  process.env.REACT_APP_ANALYSIS_API_HOST ||
  `https://analise-sesi.citecnologia.com.br`;

export const NIVEIS_ESCOLARIDADE = {
  ENSINO_FUNDAMENTAL_ID: 1,
  ENSINO_MEDIO_ID: 2,
  ESPECIALIZACAO_ID: 3,
  ENSINO_SUPERIOR_ID: 4,
  MESTRADO_ID: 5,
  DOUTORADO_ID: 6,
  POS_DOUTORADO_ID: 7
};
export const ATUACAO_PROFISSIONAL = {
  ATUANDO: 1,
  NAO_ATUANDO: 2
};
export const getAxiosConfig = () => { };
export const SELECT_PROP_TYPE = PropTypes.arrayOf(
  PropTypes.shape({
    value: PropTypes.oneOf([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  })
);
export const TipoImportacaoAnalisePsicometrica = {
  PARAMETRO_PRE_TESTE: 'PARAMETRO_PRE_TESTE',
  CURVA_CARACTERISTICA_ITEM: 'CURVA_CARACTERISTICA_ITEM',
  CURVA_PROPORCAO_RESPOSTA: 'CURVA_PROPORCAO_RESPOSTA'
};
export const AVALIACAO_ITEM_PROP_TYPE = PropTypes.shape({
  item: PropTypes.shape({
    id_item: PropTypes.number.isRequired
  }).isRequired,
  valor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
});
export const UserContext = createContext({
  user: {},
  features: [],
  permissions: {},
  groups: {},
  hasPermission: () => false,
  groupsProvider: () => { }
});
export const TIPOS_ITENS = {
  MULTIPLA_ESCOLHA_UNICA: 1,
  MULTIPLA_ESCOLHA_MULTIPLA: 2,
  RESPOSTA_BREVE: 3,
  ESCALA_LINEAR_UNICA: 4,
  ESCALA_LINEAR_MULTIPLA: 5,
  DISCURSIVO: 6,
  CONCEITO: 7,
  TABELA_EDITAVEL: 8,
  IMAGEM: 9,
  VIDEO: 10,
  FLASH_CARD: 11,
  DISCURSIVO_RESPOSTA_MULTIPLA: 12,
  LACUNA: 13,
  DISCURSIVO_COM_RUBICAS: 14
};
// export const EXAMS_UI_HOST = process.env.REACT_APP_EXAMS_UI_HOST || "http://localhost:3001"
export const EXAMS_UI_HOST =
  process.env.REACT_APP_EXAMS_UI_HOST || getExamsUrl();

export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
export const __S3_BUCKET__ = process.env.REACT_APP_S3_BUCKET || '';
export const __AWS_ACCESS_KEY__ = process.env.REACT_APP_AWS_ACCESS_KEY_ID || '';
export const __SECRET_ACCESS_KEY__ =
  process.env.REACT_APP_AWS_SECRET_ACCESS_KEY || '';
export const __AWS_REGION__ = process.env.REACT_APP_AWS_REGION || '';
